import { productListStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListStyles.orderLinesList = {
    cardExpanded: {
        container: {
            css: css`
                width: 96%;
                margin: 1rem auto;
                border: 1px solid ${getColor("common.border")};
                border-radius: 4px;
                padding: 1rem 0;
            `,
        },
    },
};
